import { render, staticRenderFns } from "./style2.vue?vue&type=template&id=57f2a644&scoped=true&"
import script from "./style2.vue?vue&type=script&lang=js&"
export * from "./style2.vue?vue&type=script&lang=js&"
import style0 from "./style2.vue?vue&type=style&index=0&id=57f2a644&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2a644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f2a644')) {
      api.createRecord('57f2a644', component.options)
    } else {
      api.reload('57f2a644', component.options)
    }
    module.hot.accept("./style2.vue?vue&type=template&id=57f2a644&scoped=true&", function () {
      api.rerender('57f2a644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/indicatorStyle/style2.vue"
export default component.exports